export default "__VITE_ASSET__SFmbE7kS__"